import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { ContactsListCallButton } from './ContactsListCallButton';
import { trackShowPhone } from './tracking';
import { ContactsList } from '../../../components/PromoDetailsModalContacts/ContactsList';
import { SingleContactWrapper } from '../../../components/PromoDetailsModalContacts/SingleContactWrapper';
import { getGaLabel, getNewbuildingId } from '../../../selectors/newbuilding';
import { getHasContacts } from '../../../selectors/newbuilding/getHasContacts';
import { selectPromoInfo } from '../../../selectors/promoInfo';
import { EPromoType, IPromo } from '../../../types/newbuilding/promos';
import { getCianMortgagePromoUrl } from '../../../utils/config';
import { useApplicationContext } from '../../../utils/withApplicationContext';
import { useAvailableContacts } from '../hooks';
import { trackCianMortgageClick } from '../tracking';

export const ActionButtonContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const gaLabel = useSelector(getGaLabel);
  const cianMortgageLink = getCianMortgagePromoUrl(config);
  const newbuildingId = useSelector(getNewbuildingId);
  const promo = useSelector(selectPromoInfo);
  const hasContacts = useSelector(getHasContacts);

  const avaliableContacts = useAvailableContacts();

  const singleContact = React.useMemo(() => {
    return avaliableContacts.builders[0] || avaliableContacts.sellers[0];
  }, [avaliableContacts]);

  const singleContactLabel = React.useMemo(() => {
    return avaliableContacts.builders.length ? 'Контакты застройщика' : 'Контакты представителя';
  }, [avaliableContacts]);

  const beforeIcon = React.useMemo(() => {
    return avaliableContacts.builders.length ? <IconCommunicationPhone16 color="icon-inverted-default" /> : undefined;
  }, [avaliableContacts]);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, promo as IPromo, newbuildingId);
  }, [gaLabel, promo, newbuildingId]);

  const handleMortgageClick = React.useCallback(() => {
    trackCianMortgageClick(promo as IPromo, newbuildingId);
  }, [promo, newbuildingId]);

  const cianMortgage = promo?.promoType === EPromoType.CianMortgage;

  if (cianMortgage) {
    return (
      <LinkButton href={cianMortgageLink} onClick={handleMortgageClick} theme="fill_secondary" size="M" fullWidth>
        Получить ипотеку онлайн
      </LinkButton>
    );
  }

  if (!hasContacts) {
    return null;
  }

  if (avaliableContacts.builders.length + avaliableContacts.sellers.length > 1) {
    return (
      <ContactsList
        builders={avaliableContacts.builders}
        sellers={avaliableContacts.sellers}
        onShowPhoneClick={onShowPhoneClick}
      />
    );
  }

  return (
    <SingleContactWrapper>
      <ContactsListCallButton
        onClick={onShowPhoneClick}
        beforeIcon={beforeIcon}
        buttonText={singleContactLabel}
        contact={singleContact}
      />
    </SingleContactWrapper>
  );
};
